module.exports = __webpack_public_path__ + "img/register.339d9839.svg";